import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import TodoGeneric from "../../Common/jsx/TodoGeneric"

class Todo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      high: [],
      medium: [],
      question: [],
      low: [],
      done: [],
    }
  }

  render() {
    return <TodoGeneric high={this.state.high} medium={this.state.medium} low={this.state.low} question={this.state.question} done={this.state.done} />
  }
}

export default withHooks(Todo)
